module.exports = __webpack_public_path__ + "img/Oman_logo_ramadan_en.a2939a95.jpg";